var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Controller, useForm, } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { TextField, Select, useStepper, Stepper } from "@opala-ds/react";
import { useMaskito } from "@maskito/react";
import FormActions from "./FormActions";
import { DocumentFileSchema, RequiredEmailSchema, RequiredPhoneSchema, RequiredStringSchema, } from "../../utils/schemas";
import { birthDateMask, cpfMask, digitsOnlyMask, phoneMask, } from "../../utils/masks";
import FileInput from "../FileInput";
import { cn } from "../../utils/cn";
import { useIsMobile } from "../../hooks/useIsMobile";
var Schema = z.object({
    cpf: RequiredStringSchema,
    nome_completo: RequiredStringSchema,
    rg: RequiredStringSchema,
    data_nascimento: RequiredStringSchema,
    sexo: RequiredStringSchema,
    email_contato: RequiredEmailSchema,
    telefone_contato: RequiredPhoneSchema,
    rg_arquivo_estudante: DocumentFileSchema,
});
export default function PersonalDataForm(_a) {
    var _this = this;
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    var onSubmit = _a.onSubmit, _r = _a.defaultValues, defaultValues = _r === void 0 ? {
        cpf: "",
        nome_completo: "",
        rg: "",
        data_nascimento: "",
        sexo: "",
        email_contato: "",
        telefone_contato: "",
    } : _r;
    var _s = useForm({
        defaultValues: defaultValues,
        resolver: zodResolver(Schema),
    }), control = _s.control, handleSubmit = _s.handleSubmit, register = _s.register, errors = _s.formState.errors;
    var nextStep = useStepper().nextStep;
    var cpfMaskRef = useMaskito({ options: cpfMask });
    var rgMaskRef = useMaskito({ options: digitsOnlyMask });
    var birthDateMaskRef = useMaskito({ options: birthDateMask });
    var phoneMaskRef = useMaskito({ options: phoneMask });
    var isMobile = useIsMobile();
    return (_jsxs("form", __assign({ className: "w-full flex flex-col space-y-12", onSubmit: handleSubmit(function (data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, onSubmit(data)];
                    case 1:
                        _a.sent();
                        nextStep();
                        return [2 /*return*/];
                }
            });
        }); }) }, { children: [_jsxs("div", __assign({ className: "flex flex-col space-y-8 py-8" }, { children: [isMobile && (_jsx("div", __assign({ className: "flex justify-start" }, { children: _jsx(Stepper.Radial, { size: 70, weight: 5 }) }))), _jsxs("div", __assign({ className: cn("grid grid-cols-4 gap-4", "max-md:flex flex-col") }, { children: [_jsx(TextField, __assign({ label: "CPF", placeholder: "Digite o seu CPF", size: "md", helperText: (_c = (_b = errors.cpf) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : "", variant: errors.cpf ? "critical" : "default" }, register("cpf"), { ref: function (node) {
                                    cpfMaskRef(node);
                                    register("cpf").ref(node);
                                } })), _jsx(TextField, __assign({ label: "RG", placeholder: "Digite o seu RG", size: "md", helperText: (_e = (_d = errors.rg) === null || _d === void 0 ? void 0 : _d.message) !== null && _e !== void 0 ? _e : "", variant: errors.rg ? "critical" : "default" }, register("rg"), { ref: function (node) {
                                    rgMaskRef(node);
                                    register("rg").ref(node);
                                } })), _jsx("div", __assign({ className: "col-span-2" }, { children: _jsx(TextField, __assign({ label: "Nome completo", placeholder: "Digite o seu nome completo", size: "md", helperText: (_g = (_f = errors.nome_completo) === null || _f === void 0 ? void 0 : _f.message) !== null && _g !== void 0 ? _g : "", variant: errors.nome_completo ? "critical" : "default" }, register("nome_completo"))) }))] })), _jsxs("div", __assign({ className: cn("grid grid-cols-4 gap-4", "max-md:flex flex-col") }, { children: [_jsx(TextField, __assign({ label: "Data de nascimento", placeholder: "dd/mm/aaaa", size: "md", helperText: (_j = (_h = errors.data_nascimento) === null || _h === void 0 ? void 0 : _h.message) !== null && _j !== void 0 ? _j : "", variant: errors.data_nascimento ? "critical" : "default" }, register("data_nascimento"), { ref: function (node) {
                                    birthDateMaskRef(node);
                                    register("data_nascimento").ref(node);
                                } })), _jsx(Controller, { control: control, name: "sexo", render: function (_a) {
                                    var _b, _c;
                                    var field = _a.field;
                                    return (_jsx(Select, { label: "Sexo", placeholder: "Selecione", defaultValue: field.value, size: "md", items: [
                                            { label: "Masculino", value: "M" },
                                            { label: "Feminino", value: "F" },
                                            { label: "Outro", value: "O" },
                                            { label: "Prefiro não informar", value: "PNI" },
                                        ], onValueChange: field.onChange, helperText: (_c = (_b = errors.sexo) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : "", variant: errors.sexo ? "critical" : "default" }));
                                } }), _jsx(TextField, __assign({ label: "E-mail", placeholder: "Digite o seu e-mail", size: "md", helperText: (_l = (_k = errors.email_contato) === null || _k === void 0 ? void 0 : _k.message) !== null && _l !== void 0 ? _l : "", variant: errors.email_contato ? "critical" : "default" }, register("email_contato"))), _jsx(TextField, __assign({ label: "Telefone", placeholder: "Digite o seu telefone", size: "md", helperText: (_o = (_m = errors.telefone_contato) === null || _m === void 0 ? void 0 : _m.message) !== null && _o !== void 0 ? _o : "Preferencialmente WhatsApp", variant: errors.telefone_contato ? "critical" : "default" }, register("telefone_contato"), { ref: function (node) {
                                    phoneMaskRef(node);
                                    register("telefone_contato").ref(node);
                                } }))] })), _jsx("p", __assign({ className: "font-semibold text-[#022A59]" }, { children: "Envio de documentos necess\u00E1rios" })), _jsx(FileInput, __assign({ label: "RG ou CPF", accept: ".pdf", defaultValue: (_p = defaultValues.rg_arquivo_estudante) === null || _p === void 0 ? void 0 : _p[0] }, register("rg_arquivo_estudante"), { error: (_q = errors.rg_arquivo_estudante) === null || _q === void 0 ? void 0 : _q.message }))] })), _jsx(FormActions, {})] })));
}
